import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('ancillary_service_area', '/ancillary_service_areas')
const actions = generator.generate()

export default actions
